<template>
    <!-- QR code dialog -->
    <v-dialog v-model="dialog" width="500px">
        <v-card>
            <v-toolbar flat dark color="primary">
                <v-toolbar-title>Growth Task QR Code</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="closeDialog">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>

            <GrowthTaskQrCode
                :task="task"
                :printId="task.id"
            ></GrowthTaskQrCode>

            <v-card-actions class="pb-5">
                <v-spacer></v-spacer>
                <v-btn
                    rounded
                    outlined
                    class="primary--text"
                    min-width="120px"
                    v-print="printObject"
                    >Print</v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import GrowthTaskQrCode from "@/components/growth/GrowthTaskQrCode.vue";

export default {
    name: "growth-task-qr-code-dialog",
    props: ["dialog", "task"],
    components: {
        GrowthTaskQrCode
    },

    data: function() {
        return {};
    },

    computed: {
        printObject() {
            return {
                id: this.task.id,
                preview: false,
                // popTitle: 'good print',
                // extraCss: "https://cdn.bootcdn.net/ajax/libs/animate.css/4.1.1/animate.compat.css, https://cdn.bootcdn.net/ajax/libs/hover.css/2.3.1/css/hover-min.css",
                // extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
                // previewBeforeOpenCallback(vue) {
                //     vue.printLoading = true;
                //     console.log("Loading preview");
                // },
                // previewOpenCallback(vue) {
                //     console.log("Preview loaded");
                //     vue.printLoading = false;
                // },
                // beforeOpenCallback(vue) {
                //     console.log("Before open");
                // },
                // openCallback(vue) {
                //     vue.closeDialog();
                //     console.log("Opend printer window");
                // }
                closeCallback(vue) {
                    // console.log("Closed printer window");
                    vue.closeDialog();
                }
            };
        }
    },
    methods: {
        closeDialog() {
            this.$emit("update:dialog", false);
        }
    }
};
</script>


<style scoped>
.box-border {
    border-style: solid;
    padding: 30px;
}
</style>
